const _ = require("underscore");

module.exports = function (number) {
  if (_.isNumber(number) && !_.isNaN(number)) {
    // NOTE: toLocaleString has terrible browser support - use this instead
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return "N/A";
};
